import React from 'react'

const Image = (props) => {
  const { imageSrc, altText,className, onClick } = props;
  return (
      <img src={imageSrc} alt={altText} className={className} onClick={onClick}/>
  );
};

export default Image